import { DUTY_LOG_EXACT_MATCH_FIELDS } from './DutyLogConfig';

export interface DutyLogFilterDef {
    field: string;
    operator: 'equals' | 'contains' | 'greaterThan' | 'lessThan';
    value: unknown;
}

/**
 * #693-class fix — build the duty log export filter definitions with the SAME
 * per-field operators the list applies, instead of forcing `contains` for every
 * non-range filter. Dropdown (exact-match) fields use `equals`; free-text fields
 * use `contains`; a {from,to} range decomposes into greaterThan/lessThan.
 */
export function buildDutyLogFilterDefinitions(
    currentFilters: Record<string, any>,
): DutyLogFilterDef[] {
    return Object.entries(currentFilters)
        .filter(([, v]) => v != null && v !== '')
        .flatMap(([field, value]): DutyLogFilterDef[] => {
            if (typeof value === 'object' && value.from) {
                return [
                    { field, operator: 'greaterThan', value: value.from },
                    { field, operator: 'lessThan', value: value.to },
                ];
            }
            const operator = DUTY_LOG_EXACT_MATCH_FIELDS.has(field) ? 'equals' : 'contains';
            return [{ field, operator, value }];
        });
}
